module.exports = __webpack_public_path__ + "img/awinnovate-fr-pix.2e8bfd38.jpg";